import { create } from 'zustand';
import { INIT_TZS, MAX_TIMEZONES, ITimezoneStore } from '../config';
import { persist } from 'zustand/middleware';

export const useTimezoneStore = create<ITimezoneStore>()(
  persist(
    (set) => ({
      selected: INIT_TZS,
      addTimezone: (tz) => {
        set((state) => {
          const alreadySelected = state.selected.some(
            (item) => item.tzCode === tz.tzCode,
          );
          if (alreadySelected || state.selected.length >= MAX_TIMEZONES) {
            return state;
          }
          return { selected: [...state.selected, tz] };
        })
      },
      removeTimezone: (tzCode) => {
        set((state) => ({
          selected: state.selected.filter((item) => item.tzCode !== tzCode),
        }))
      },
    }), {
    name: 'worldtime'
  }
  ),

);